import React, { Component } from 'react';
import PropTypes from 'prop-types';

// logic dependencies
import { BORDER_POSITION } from 'logic/data/Izenda.PropertiesBuilderConstants.js'
import { TileTypes } from 'logic/data/Izenda.ReportPartKPIConstants.js';

// local dependencies
import KPITextContainer from './Izenda.KPITextContainer';
import KPIMetricContainer from './Izenda.KPIMetricContainer';

class TileBorderPropertyPreview extends Component {

    renderContainer = () => {
        const {
            previewData: {
                reportPart,
                tile,
                tile: {
                    id,
                    tileType,
                }
            }
        } = this.props;

        if (tileType === TileTypes.text.id) {
            return (
                <KPITextContainer
                    id={id}
                    tile={tile}
                    isPreview={false}
                    isBorderConfig={true}
                />
            );
        } else if (tileType === TileTypes.metric.id) {
            return (
                <KPIMetricContainer 
                    isBorderConfig={true}
                    reportPart={reportPart}
                />
            );
        }
    }

    render() {
        const style = {
            ...this.props.getStylesBorder(BORDER_POSITION.ALL)
        };
        return (
            <div className="border-preview" style={style}>
                {this.renderContainer()}
            </div>
        )
    }
}

TileBorderPropertyPreview.propTypes = {
    getStylesBorder: PropTypes.func.isRequired,
    previewData: PropTypes.object.isRequired
};

export default TileBorderPropertyPreview;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.TileBorderPropertyPreview.jsx